exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/vue-tel-input/~/core-js/internals/object-get-own-property-symbols.js
// module id = 1503
// module chunks = 1